import { IQuoteAttachmentDocumentsPreset } from "../queries/apiTypes";

export const trimEmptySpacesHandler = (nameStr: string) => {
    if (nameStr && typeof nameStr === 'string') {
        return nameStr.trim().replace(/\s+/g, ' ');
    } else {
        return '';
    }
};

export const removeAllSpacesHandler = (nameStr: string) => {
    if (nameStr && typeof nameStr === 'string') {
        return nameStr?.trim().replace(/\s+/g, '');
    } else {
        return '';
    }
};

export const sanitizePhoneNumber = (inputValue: string): string => {
    if (inputValue && typeof inputValue === 'string') {
        return inputValue?.trim().replace(/[^0-9+-]/g, '');
    } else {
        return '';
    }
};

export const countryOptions = [
    { label: 'USA', value: 'USA' },
    { label: 'Canada', value: 'Canada' }
];

export const USA = 'USA';
export const CANADA = 'Canada';

export const modifiedStateList = (countryStates: string[]) => {
    const stateOptions: { label: string; value: string }[] = countryStates.map((data: string) => ({ label: data, value: data }));

    return stateOptions;
};

export const getHeadingForModal = (currentTab: string) => {
    if (currentTab === 'branchDetails') {
        return 'Branch Details';
    } else if (currentTab === 'branchBranding') {
        return 'Branch Branding';
    } else if (currentTab === 'bomSettings') {
        return 'BOM'
    } else if (currentTab === 'quoteCustomisation') {
        return 'Quote Customisation';
    } else if (currentTab === 'submittalCustomisation') {
        return 'Submittal Customisation';
    } else if (currentTab === 'omCustomisation') {
        return 'O&M Customisation';
    } else {
        return '';
    }
};

export const attachmentDocumentArrFormatter = (data: IQuoteAttachmentDocumentsPreset[]) => {
    if (!data || data?.length === 0) {
        return [];
    } else {
        const formattedData = data.map((el) => ({ name: el.name, s3_url: el.s3_url }));
        return formattedData;
    }
};

export const generateBaseEditLocUrl = (locationId: number | string) => {
    return `/v2/settings/company-locations/edit/${locationId}`;
};
